import { render } from "./SectionHue.vue?vue&type=template&id=e1a2cc16"
import script from "./SectionHue.vue?vue&type=script&lang=js"
export * from "./SectionHue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__